/** Verdict sentence shown under both diff page headers, keyed by release status. */
export const DIFF_CHECK_TEXT = {
    fail: "Found suspicious differences potentially resulting from software supply chain compromise. Investigate root cause.",
    pass: "Compared files have no suspicious differences.",
};
//# sourceMappingURL=diffCheckText.js.map